import { List, Map } from 'immutable';

import * as types from './types';
import * as functions from './functions';
import {
  LS_DASHBOARD_FILTERS,
  FILTER_AUTOMATED_BUILDS,
  FILTER_AUTOMATED_TESTS,
  FILTER_HEADLESS_BUILDS,
  FILTER_HEADLESS_TESTS,
  FILTER_TYPE_STATUS,
  FILTER_TYPE_OWNERSHIP,
} from './constants';

const initialStructure = new Map({
  [FILTER_AUTOMATED_BUILDS]: new Map({
    [FILTER_TYPE_STATUS]: new List(),
    [FILTER_TYPE_OWNERSHIP]: new Map(),
  }),
  [FILTER_AUTOMATED_TESTS]: new Map({
    [FILTER_TYPE_STATUS]: new List(),
    [FILTER_TYPE_OWNERSHIP]: new Map(),
  }),
  [FILTER_HEADLESS_BUILDS]: new Map({
    [FILTER_TYPE_STATUS]: new List(),
    [FILTER_TYPE_OWNERSHIP]: new Map(),
  }),
  [FILTER_HEADLESS_TESTS]: new Map({
    [FILTER_TYPE_STATUS]: new List(),
    [FILTER_TYPE_OWNERSHIP]: new Map(),
  }),
});

const lsFilters = window.localStorage.getItem(LS_DASHBOARD_FILTERS);
const initialState = lsFilters ?
  functions.deserializeFiltersFromLS(JSON.parse(lsFilters)) :
  initialStructure;

const filtersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.TOGGLE_STATUS: {
      const index = state.getIn([payload.type, FILTER_TYPE_STATUS]).indexOf(payload.data);
      const updatedFilters = index === -1 ?
        state.updateIn([payload.type, FILTER_TYPE_STATUS], (status) => status.push(payload.data)) :
        state.updateIn([payload.type, FILTER_TYPE_STATUS], (status) => status.delete(index));
      window.localStorage.setItem(
        LS_DASHBOARD_FILTERS,
        functions.serializeFiltersToLS(updatedFilters),
      );
      return updatedFilters;
    }
    case types.CLEAR_STATUSES: {
      const updatedFilters = state.setIn(
        [payload.type, FILTER_TYPE_STATUS],
        initialStructure.getIn([payload.type, FILTER_TYPE_STATUS]),
      );
      window.localStorage.setItem(
        LS_DASHBOARD_FILTERS,
        functions.serializeFiltersToLS(updatedFilters),
      );
      return updatedFilters;
    }
    case types.SELECT_OWNER: {
      const updatedFilters = state.setIn(
        [payload.type, FILTER_TYPE_OWNERSHIP],
        new Map(payload.data),
      );
      window.localStorage.setItem(
        LS_DASHBOARD_FILTERS,
        functions.serializeFiltersToLS(updatedFilters),
      );
      return updatedFilters;
    }
    case types.CLEAR_OWNER: {
      const updatedFilters = state.setIn(
        [payload.type, FILTER_TYPE_OWNERSHIP],
        initialStructure.getIn([payload.type, FILTER_TYPE_OWNERSHIP]),
      );
      window.localStorage.setItem(
        LS_DASHBOARD_FILTERS,
        functions.serializeFiltersToLS(updatedFilters),
      );
      return updatedFilters;
    }
    default:
      return state;
  }
};

export default filtersReducer;
